export default [
    { "token": "wstETH", "boost": 200 },
    { "token": "rETH", "boost": 200 },
    { "token": "eETH", "boost": 200 },
    { "token": "ezETH", "boost": 200 }
]
